export default function unwrapPagedCollections(value) {
    const typeString = Object.prototype.toString.call(value);
    if (typeString === '[object Object]') {
        if ('edges' in value) {
            return (value.edges || [])
                .filter(Boolean)
                .map((edge) => unwrapPagedCollections(edge.node))
                .filter(Boolean);
        }
        return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, unwrapPagedCollections(v)]));
    }
    if (typeString === '[object Array]') {
        return value.map(unwrapPagedCollections);
    }
    return value;
}
